import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCustomFieldOptions = {
  name: "getCustomFieldOptions" as const,
  input: z.object({
    customFieldId: zExt.objectId(),
    /**
     * Case-insensitive substring filter for non-curated string fields. Server
     * forwards this to Snowflake as `ILIKE '%search%'`. Ignored when the
     * declaration has a merchant-curated picklist or is non-string-typed.
     */
    searchString: z.string().optional(),
  }),

  output: z.object({
    name: z.string(),
    options: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
